// extracted by mini-css-extract-plugin
export default {"subtle-description":"PortfolioAllocationCalculator_subtle-description__NK1Av"};